/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import TrainingNav from '../../components/BiteU/BiteUNav';
import { Grid } from '@mui/material';
import { BackButton, NextButton } from 'components/Common/MUIStyledComponents';
import ReactPlayer from 'react-player/lazy';
import BiteUAPI from 'api/BITEUAPI';

const BITEUCoursePage: React.FC = (props: any) => {
  const { cur_user } = useContext(GlobalContext);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  if (!props.location.state) {
    return <Redirect to='/' />;
  }
  const { cur_course, user_status, cur_lesson } = props.location.state;

  const [ activeLesson, setActiveLesson ] = useState<any>({});
  const [ activeProgress, setActiveProgress ] = useState<any>({});
  const [ status, setStatus ] = useState<any>({});
  const [ playedTime, setPlayedTime ] = useState(0);
  const [ playedPerc, setPlayedPerc ] = useState(0);
  const [ isPlaying, setIsPlaying ] = useState(true);
  const [ isReady, setIsReady ] = useState(false);

  const playerRef = useRef<any>();

  const lessons = activeProgress.currentProgress;

  const completeCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#47CD89'/>
  </svg>;

  const progressCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#FDB022'/>
  </svg>;

  const defaultCheck = <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M13.807 6.29825C13.9825 6.09941 14.2164 6 14.5088 6C14.7895 6 15.0234 6.09941 15.2105 6.29825C15.4094 6.48538 15.5088 6.7193 15.5088 7C15.5088 7.2807 15.4094 7.51462 15.2105 7.70175L9.31579 13.5965C9.10526 13.807 8.83626 13.9123 8.50877 13.9123C8.19298 13.9123 7.92398 13.807 7.70175 13.5965L4.80702 10.7018C4.60819 10.5263 4.50877 10.2924 4.50877 10C4.50877 9.7193 4.60819 9.48538 4.80702 9.29825C5.00585 9.09941 5.23977 9 5.50877 9C5.80117 9 6.03509 9.09941 6.21053 9.29825L9.10526 12.193C9.16374 12.2515 9.07602 12.2924 8.84211 12.3158C8.61988 12.3392 8.39181 12.3392 8.15789 12.3158C7.93567 12.2924 7.8538 12.2515 7.91228 12.193L13.807 6.29825ZM10 18C11.4971 18 12.8538 17.6491 14.0702 16.9474C15.2982 16.2456 16.2573 15.2865 16.9474 14.0702C17.6491 12.8421 18 11.4854 18 10C18 8.50292 17.6491 7.1462 16.9474 5.92982C16.2573 4.70175 15.2982 3.74269 14.0702 3.05263C12.8538 2.35088 11.4971 2 10 2C8.51462 2 7.15789 2.35088 5.92982 3.05263C4.71345 3.74269 3.75439 4.70175 3.05263 5.92982C2.35088 7.1462 2 8.50292 2 10C2 11.4854 2.35088 12.8421 3.05263 14.0702C3.75439 15.2865 4.71345 16.2456 5.92982 16.9474C7.15789 17.6491 8.51462 18 10 18ZM10 20C8.19883 20 6.52632 19.5556 4.98246 18.6667C3.45029 17.7661 2.23392 16.5497 1.33333 15.0175C0.444445 13.4737 5.96046e-08 11.8012 5.96046e-08 10C5.96046e-08 8.18713 0.444445 6.51462 1.33333 4.98246C2.23392 3.45029 3.45029 2.23977 4.98246 1.35088C6.52632 0.450292 8.19883 -4.76837e-07 10 -4.76837e-07C11.8129 -4.76837e-07 13.4854 0.450292 15.0175 1.35088C16.5497 2.23977 17.7602 3.45614 18.6491 5C19.5497 6.53216 20 8.19883 20 10C20 11.8012 19.5497 13.4737 18.6491 15.0175C17.7602 16.5497 16.5439 17.7661 15 18.6667C13.4678 19.5556 11.8012 20 10 20Z' fill='#BDBEC1'/>
  </svg>;

  const findProgress = (): any => {
    const filteredArr = user_status.data.progress.filter((prog: any) => {
      return prog.course === cur_course.name;
    });
    return filteredArr;
  };

  const findCurStatus = (): any => {
    const progArr: any = findProgress();
    const filteredArr = progArr[0].currentProgress.filter((les: any) => {
      return les.lesson.name === activeLesson.lesson.name;
    });
    return filteredArr;
  };

  const findProgIndex = user_status.data.progress.findIndex((prog: any) => {
    return prog.course === cur_course.name;
  });

  const findStatusIndex = (): number => {
    const progArr: any = findProgress();
    const index = progArr[0].currentProgress.findIndex((stat: any) => {
      return stat.lesson.name === activeLesson.lesson.name;
    });
    return index;
  };

  const checkLessonComplete = (name: string) => {
    const completed = activeProgress.completedLessons.filter((less: any) => {
      return less.name === name;
    });
    if (completed.length) {
      return true;
    }
    return false;
  };

  const checkLessonInProgress = (name: string) => {
    const arr = activeProgress.currentProgress.filter((less: any) => {
      return less.lesson.name === name;
    });

    if (arr[0].currentTime !== 0 && arr[0].currentTime !== 1) {
      return true;
    }
    return false;
  };

  const checkCourseCurrent = () => {
    const checkArr = user_status.data.current.filter((c: any) => {
      if (!c || c === null) {
        return false;
      }
      return c.name === cur_course.name;
    });
    if (!checkArr.length) {
      handleAddCourseCurrent();
    }
  };

  const handleAddCourseCurrent = async() => {
    const body = user_status.data;
    body.current.push(cur_course);
    await BiteUAPI.updateUserTrainingStatus(body);
  };

  const makeUpdate = async() => {
    checkCourseCurrent();
    const new_val = { ...activeProgress };
    const new_status = { ...status };

    if (playedPerc !== 1 && new_val.currentPercent !== 1) {
      new_status.currentPercent = playedPerc;
      new_status.currentTime = playedTime;
    }

    const body = user_status.data;
    const progIndex = findProgIndex;
    const statIndex = findStatusIndex();

    new_val.currentProgress[statIndex] = new_status;
    body.progress[progIndex] = new_val;

    await BiteUAPI.updateUserTrainingStatus(body);
  };

  const handleCompletedCourse = async() => {
    const body = user_status.data;
    const new_cur = body.current.filter((c: any) => {
      return c.name !== cur_course.name;
    });

    body.current = new_cur;
    body.completed.push(cur_course);
    await BiteUAPI.updateUserTrainingStatus(body);
  };

  const handleNext = async(num: number) => {
    const newLes = lessons.filter((les: any) => {
      return les.lesson.number === num + 1;
    });
    await setActiveLesson(newLes[0]);
    setIsReady(false);

    await makeUpdate();
  };

  const handleBack = async(num: number) => {
    const newLes = lessons.filter((les: any) => {
      return les.lesson.number === num - 1;
    });
    setActiveLesson(newLes[0]);
    setIsReady(false);

    await makeUpdate();
  };

  const handleEnd = async() => {
    const alreadyCompleted = activeProgress.completedLessons.filter((les: any) => {
      return les.name === activeLesson.lesson.name;
    });

    if (alreadyCompleted.length) {
      handleNext(activeLesson.lesson.number);
    } else {
      const new_val = { ...activeProgress };
      const new_status = { ...status };

      new_status.currentPercent = 1;
      new_status.currentTime = 1;

      const statIndex = findStatusIndex();

      new_val.currentProgress[statIndex] = new_status;
      new_val.completedLessons.push(activeLesson.lesson);

      const body = user_status.data;
      const index = findProgIndex;

      body.progress[index] = new_val;
      const res = await BiteUAPI.updateUserTrainingStatus(body);
      if (res?.result.progress[findProgIndex].completedLessons.length === lessons.length) {
        handleCompletedCourse();
      } else if (activeLesson.lesson.number !== cur_course.lessons.length) {
        handleNext(activeLesson.lesson.number);
      }
    }
  };

  useEffect(() => {
    setActiveLesson(cur_lesson);
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  useEffect(() => {
    if (Object.keys(activeLesson).length !== 0) {
      const actProg = findProgress();
      const curStat = findCurStatus();
      setActiveProgress(actProg[0]);
      setStatus(curStat[0]);
    }
  }, [ activeLesson ]);

  useEffect(() => {
    const handleUnload = async() => {
      await makeUpdate();
    };
    window.addEventListener('unload', handleUnload);
    return () => {
      window.removeEventListener('unload', handleUnload);
    };
  }, []);

  const onReady = useCallback(() => {
    if (!isReady) {
      if (activeLesson.currentTime !== 1) {
        const timeToStart = activeLesson.currentTime;
        playerRef.current.seekTo(timeToStart, 'seconds');
      } else {
        const timeToStart = 0;
        playerRef.current.seekTo(timeToStart, 'seconds');
      }
      setIsReady(true);
    }
  }, [ isReady, activeLesson ]);

  if (!activeProgress || !status || !activeLesson || Object.keys(activeLesson).length === 0 || Object.keys(activeProgress).length === 0 || Object.keys(status).length === 0) {
    return (
      <div className='spinner-spacer-bite-u'>
        <div className='loader'>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <TrainingNav basePath={`BITE U / ${cur_course.name} / `} curPath={`Lesson ${activeLesson.lesson.number}`} />
      <section className='home-content-body Training-HeaderDown' style={{ minHeight: 0 }}>

        <div className='bite-u-page-spacer'></div>
        <div className='HomeDashboard-container'>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <div className='bite-u-c-vid-cont'>
                <div className='bite-u-c-vid-top'>
                  <h1>Video {activeLesson.lesson.number}</h1>
                  <h2>{activeLesson.lesson.name}</h2>
                </div>
                <div className='bite-u-c-vid'>
                  <ReactPlayer url={activeLesson.lesson.vidLink}
                    playing={isPlaying}
                    className='training-video'
                    controls
                    width='100%' height='100%'
                    onReady={onReady}
                    onEnded={handleEnd}
                    ref={playerRef}
                    onProgress={(progress: any) => {
                      setPlayedTime(progress.playedSeconds);
                      setPlayedPerc(progress.played);
                    }}
                  >
                  </ReactPlayer>
                </div>
                <div className='bite-u-c-btn-cont'>
                  {activeLesson.lesson.number !== 1 ? (
                    <BackButton onClick={() => handleBack(activeLesson.lesson.number)} >Previous Lesson</BackButton>
                  ) : (
                    <div style={{ width: '140px' }}></div>
                  )}
                  <NextButton onClick={makeUpdate}>Save Progress</NextButton>
                  {activeLesson.lesson.number !== lessons.length ? (
                    <BackButton onClick={() => handleNext(activeLesson.lesson.number)}>Next Lesson</BackButton>
                  ) : (
                    <div style={{ width: '112px' }}></div>
                  )
                  }
                </div>
              </div>
            </Grid>

            <Grid item xs={12}>
              <div className='bite-u-c-lessons'>
                <h1>Videos</h1>
                <div className='bite-u-lessons-table'>
                  {lessons.map((lesson: any, i: number) => (
                    <div className={i === lessons.length - 1 ? 'bite-u-lesson-last' : 'bite-u-lesson'} key={i}>
                      <div className='bite-u-lesson-icon'>
                        {checkLessonComplete(lesson.lesson.name) ? completeCheck :
                          lesson.lesson.name === activeLesson.lesson.name ? progressCheck : checkLessonInProgress(lesson.lesson.name) ? progressCheck :
                            defaultCheck}
                      </div>
                      <div className='bite-u-lesson-name-cont'>
                        <h6>{lesson.lesson.name}</h6>
                        <h5 onClick={() => handleNext(lesson.lesson.number - 1)} aria-disabled={lesson.lesson.name === activeLesson.lesson.name}>
                          {lesson.lesson.name === activeLesson.lesson.name ? 'In Progress' :
                            checkLessonComplete(lesson.lesson.name) ? 'Start Over' : checkLessonInProgress(lesson.lesson.name) ? 'Continue' :
                              'Start Video'}
                        </h5>
                      </div>
                    </div>
                  )
                  )}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>

      </section>
    </>
  );
};

export default BITEUCoursePage;
